import {RouteComponentProps} from 'react-router-dom';
import * as queryString from 'query-string';
import {useAsync} from "react-async"
import {httpClient} from '../service/ApiService';
import CompleteHtml from "./delivery/confirm";
import LoadingHtml from '../shared/Loading';
import ErrorPage from "../shared/ErrorPage";
import {ActionResult, HttpMethod} from "../model";


const CouponDelieryConfirm = (props: RouteComponentProps<{ id: string }>) => { // 추가
    const location = props.location;
    const match = props.match;
    const search = queryString.parse(location.search);
    const id = match.params.id;
    const q = search.q;
    const url = `coupons/delivery/confirm/${id}`;
    const query = `q=${q}`;
    const body = {searchText: q};
    const options = {
        promiseFn: httpClient,
        method: HttpMethod.POST,
        url, query, body
    };
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    if (isLoading) return  <LoadingHtml/>;
    if (error) {
        console.error('error:'+error);
        return <ErrorPage />;
    }
    if (!act) return null;
    if (act.result) {
        console.log('success');
        return <CompleteHtml act={act} flag={id}/>;
    } else {
        console.error('act result :'+JSON.stringify(act));
        return <CompleteHtml act={act} flag={id}/>
    }
};

export default CouponDelieryConfirm;
